export const locationProvider = $locationProvider => {
  'ngInject';
  $locationProvider.html5Mode(true);
};



// WEBPACK FOOTER //
// ./src/providers/locationProvider.js